/**
 * Velora Reviews Carousel — vanilla JavaScript only.
 */
(function () {
  'use strict';

  var AUTOPLAY_MS = 6000;
  var BREAKPOINTS = { tablet: 768, desktop: 1024 };

  function getAutoplayMs(root) {
    var custom = root && root.getAttribute('data-autoplay-ms');
    if (custom) {
      var parsed = parseInt(custom, 10);
      if (!isNaN(parsed) && parsed >= 3000) return parsed;
    }
    return AUTOPLAY_MS;
  }

  function getPerView() {
    var w = window.innerWidth;
    if (w >= BREAKPOINTS.desktop) return 3;
    if (w >= BREAKPOINTS.tablet) return 2;
    return 1;
  }

  function initCarousel(root) {
    if (!root || root.getAttribute('data-carousel-init') === 'true') return;

    var track = root.querySelector('[data-carousel-track]');
    var slides = track ? track.querySelectorAll('.fpv-carousel-slide') : [];
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');

    if (!track || !slides.length) return;

    root.setAttribute('data-carousel-init', 'true');

    var currentIndex = 0;
    var autoplayTimer = null;
    var isPaused = false;

    function getMaxIndex() {
      return Math.max(0, slides.length - getPerView());
    }

    function getPageCount() {
      var perView = getPerView();
      return Math.max(1, Math.ceil(slides.length / perView));
    }

    function getActivePage() {
      var perView = getPerView();
      return Math.min(getPageCount() - 1, Math.floor(currentIndex / perView));
    }

    function updateTrack() {
      var perView = getPerView();
      var slideWidth = 100 / perView;
      track.style.setProperty('--fpv-carousel-per-view', String(perView));
      currentIndex = Math.min(currentIndex, getMaxIndex());
      track.style.transform = 'translate3d(-' + (currentIndex * slideWidth) + '%, 0, 0)';
      updateDots();
      updateButtons();
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = getPageCount();
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fpv-carousel-dot';
        dot.setAttribute('aria-label', 'Go to review page ' + (i + 1));
        dot.setAttribute('data-carousel-dot', String(i));
        dot.addEventListener('click', function () {
          var page = parseInt(this.getAttribute('data-carousel-dot'), 10);
          goToPage(page);
          resetAutoplay();
        });
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var activePage = getActivePage();
      dotsWrap.querySelectorAll('.fpv-carousel-dot').forEach(function (dot, i) {
        var isActive = i === activePage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      updateTrack();
    }

    function goToPage(page) {
      goTo(page * getPerView());
    }

    function next() {
      var perView = getPerView();
      var max = getMaxIndex();
      if (currentIndex >= max) {
        goTo(0);
      } else {
        goTo(Math.min(currentIndex + perView, max));
      }
    }

    function prev() {
      var perView = getPerView();
      if (currentIndex <= 0) {
        goTo(getMaxIndex());
      } else {
        goTo(Math.max(currentIndex - perView, 0));
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (isPaused) return;
      autoplayTimer = setInterval(function () {
        next();
      }, getAutoplayMs(root));
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        resetAutoplay();
      });
    }

    root.addEventListener('mouseenter', function () {
      isPaused = true;
      stopAutoplay();
    });

    root.addEventListener('mouseleave', function () {
      isPaused = false;
      startAutoplay();
    });

    root.addEventListener('focusin', function () {
      isPaused = true;
      stopAutoplay();
    });

    root.addEventListener('focusout', function () {
      isPaused = false;
      startAutoplay();
    });

    var touchStartX = 0;
    root.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      var touchEndX = event.changedTouches[0].screenX;
      var diff = touchEndX - touchStartX;
      if (Math.abs(diff) < 50) return;
      if (diff < 0) next();
      else prev();
      resetAutoplay();
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        updateTrack();
      }, 150);
    });

    buildDots();
    updateTrack();
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-fpv-reviews-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
